// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ArticleCalculator_wrapper__zM9GR","content":"ArticleCalculator_content__2Ewz1"};